import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Search, UserRound } from 'lucide-react';
import { FormEvent, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const Route = createFileRoute('/pep-vida/_authed/pacientes/')({
  component: PacientesPage,
});

function PacientesPage() {
  const [codigo, setCodigo] = useState('');
  const navigate = useNavigate();

  function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const cdPaciente = Number(codigo.trim());
    if (!Number.isInteger(cdPaciente) || cdPaciente <= 0) return;
    navigate({
      to: '/pep-vida/pacientes/$cdPaciente',
      params: { cdPaciente: String(cdPaciente) },
    });
  }

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserRound className="h-5 w-5 text-primary" />
            Pacientes
          </CardTitle>
          <CardDescription>Busque pelo codigo Clinux para abrir o prontuario do paciente.</CardDescription>
        </CardHeader>
        <CardContent>
          <form className="grid gap-3 sm:grid-cols-[1fr_auto] sm:items-end" onSubmit={onSubmit}>
            <div className="space-y-2">
              <Label htmlFor="cdPaciente">Codigo do paciente</Label>
              <Input
                id="cdPaciente"
                inputMode="numeric"
                value={codigo}
                onChange={(event) => setCodigo(event.target.value)}
                placeholder="Ex: 54682"
              />
            </div>
            <Button type="submit">
              <Search className="mr-2 h-4 w-4" />
              Buscar
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
